import {isUndefined} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {AccountAvatar} from '../../../components/common/avatars/accountAvatar';
import {StyledFlex} from '../../components/reportViewer/reportCommons';
import {MetricAccountRenderer} from '../analyticsFormatHelpers';

/*
 * Constants.
 */

const accountAvatarSize = 16;

/*
 * Props.
 */

interface AccountValueProps {
  accountId?: number;
  name?: string;
  avatarUrl?: string;
}

/*
 * Styles.
 */

const StyledAvatar = styled(AccountAvatar)`
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin-right: 4px;
`;

const StyledAccountName = styled.div`
  ${ellipsis()}
`;

/*
 * Formatter.
 */

const AccountValue: FC<AccountValueProps> = (props) => {
  const {name, avatarUrl} = props;
  const emptyCell = <>--</>;

  if (isUndefined(name)) {
    return emptyCell;
  }

  return (
    <StyledFlex>
      <StyledAvatar avatarUrl={avatarUrl} size={accountAvatarSize} avatarIconSize={accountAvatarSize} />
      <StyledAccountName>{name}</StyledAccountName>
    </StyledFlex>
  );
};

export const renderAccountValue: MetricAccountRenderer = ({id, value, avatarUrl}) => (
  <AccountValue accountId={id} name={value} avatarUrl={avatarUrl} />
);
